<template>
    <div class="group relative h-12 w-60 border-2 border-black overflow-hidden">
        <select
            :value="sort"
            @change="$emit('sort-updated', $event.target.value)"
            class="w-full h-full px-4 text-sm font-bold appearance-none outline-hidden border-0 cursor-pointer"
        >
            <option value="-created_at">Новинки</option>
            <option value="-price">Від дорогих до дешевих</option>
            <option value="price">Від дешевих до дорогих</option>
        </select>
        <span
            class="absolute top-1/2 right-0 mr-3 transform -translate-y-1/2 text-black group-hover:text-indigo-500">
            <Chevron class="rotate-90 h-3"/>
        </span>
    </div>
</template>

<script>
import Chevron from "@/Components/Svg/Chevron.vue";

export default {
    components: {Chevron},
    props: {
        sort: String
    }
}
</script>
